import moment from 'moment'

export const formatDate = (date: Date | string | undefined) => {
  return moment(date).format('YYYY年MM月DD日 Ahh:mm')
}
